import React from "react";

/**
 * Generic page header. Used inside AppShell main area.
 */
export default function PageHeader({ title, subtitle, breadcrumbs = [], actions, testid }) {
  return (
    <div className="mb-8" data-testid={testid || "page-header"}>
      {breadcrumbs.length > 0 && (
        <nav className="flex items-center gap-2 mb-2 t-caption">
          {breadcrumbs.map((b, i) => (
            <React.Fragment key={i}>
              {b.href ? (
                <a href={b.href} className="text-slate2 hover:text-ink">{b.label}</a>
              ) : (
                <span className="text-slate2">{b.label}</span>
              )}
              {i < breadcrumbs.length - 1 && <span className="text-muted2">/</span>}
            </React.Fragment>
          ))}
        </nav>
      )}
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div>
          <h1 className="t-h1">{title}</h1>
          {subtitle && <p className="t-body text-slate2 mt-1">{subtitle}</p>}
        </div>
        {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, description, action, testid }) {
  return (
    <div className="card2 py-16 px-6 text-center max-w-md mx-auto" data-testid={testid || "empty-state"}>
      {Icon && (
        <div className="w-12 h-12 rounded-full bg-surface flex items-center justify-center mx-auto mb-4">
          <Icon size={24} className="text-muted2" />
        </div>
      )}
      <h3 className="t-h4 mb-2">{title}</h3>
      {description && <p className="t-body-sm text-slate2 mb-6">{description}</p>}
      {action}
    </div>
  );
}

export function StatusPill({ status }) {
  const map = {
    active: "badge-active",
    draft: "badge-draft",
    archived: "badge-failed",
    revoked: "badge-failed",
    invited: "badge-locked",
    started: "badge-locked",
    in_progress: "badge-pending",
    awaiting_review: "badge-pending",
    complete: "badge-verified",
    stalled: "badge-failed",
    expired: "badge-failed",
  };
  return <span className={`badge2 ${map[status] || "badge-draft"}`} data-testid={`status-${status}`}>{(status || "").replace(/_/g, " ")}</span>;
}
